
import {
  computed,
  defineComponent, inject, onMounted, ref, Ref,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
// eslint-disable-next-line import/no-cycle
import { useMainStore } from '@/store/mainStore';
import AppLoader from '@/components/UI/AppLoader.vue';
import RegistrationDoctorCard from '@/modules/registration/components/RegistrationDoctorCard.vue';
import AppButton from '@/components/UI/AppButton.vue';
import { IDoctor, IUserSearchData } from '@/types/interfaces';
// eslint-disable-next-line import/no-cycle
import RegistrationService from '@/modules/registration/services/RegistrationService';
import { useRegistrationStore } from '../store/registrationStore';
// eslint-disable-next-line import/no-cycle
import MonitoringService from '@/services/MonitoringService';
import { HEALTHCARE } from '@/types/enums';

export type TSelectedUser = null | number;

export default defineComponent({
  components: {
    AppLoader,
    AppButton,
    RegistrationDoctorCard,
  },
  setup() {
    const router = useRouter();
    const registrationStore = useRegistrationStore();
    const mainStore = useMainStore();

    const dataRequest: Ref<boolean> = ref(false);
    const doctors: Ref<IDoctor[]> = ref([]);
    const selectedDoctor: Ref<IDoctor | null> = ref(null);

    const skipNpiUrl = computed(() => {
      const { profession } = registrationStore.createUser;
      if (profession === HEALTHCARE.OTHER) {
        return 'step-3a';
      }
      if (profession === HEALTHCARE.NURSING) {
        return 'step-3b';
      }
      if (profession === HEALTHCARE.ALLIED_HEALTH) {
        return 'step-3c';
      }
      if (profession === HEALTHCARE.DENTAL) {
        return 'step-3d';
      }
      if (profession === HEALTHCARE.MEDICAL) {
        return 'step-3e';
      }
      return 'step-7';
    });

    function handleSelect(npi: number) {
      selectedDoctor.value = doctors.value.find((doctor) => doctor.npi === npi) || null;
    }

    function getUserData() {
      dataRequest.value = true;

      const playload: IUserSearchData = {
        firstName: registrationStore.searchUser.firstName,
        lastName: registrationStore.searchUser.lastName,
      };

      RegistrationService.getDoctorsData(playload).then((response) => {
        if (response.success) {
          doctors.value = response.results.data;
          handleSelect(registrationStore.createUser.npi);
        }
      }).finally(() => {
        dataRequest.value = false;
        if (!doctors.value.length) {
          router.replace('step-4a');
        }
      });
    }

    // function resolveState(location: string): string {
    //   const tempLocation = location.split(' ');
    //   tempLocation.shift();
    //   return tempLocation.join(' ');
    // }

    function nextStep() {
      if (selectedDoctor.value) {
        registrationStore.$patch({
          createUser: {
            npi: selectedDoctor.value.npi,
            state: selectedDoctor.value.location,
            firstName: selectedDoctor.value.firstName,
            lastName: selectedDoctor.value.lastName,
          },
        });
      }

      router.push('step-7');
    }

    onMounted(() => {
      if (registrationStore.searchUser.lastName) {
        getUserData();
      } else {
        router.push('step-2a');
      }
      MonitoringService.sendPageMountedSpeed();
    });

    return {
      doctors,
      mainStore,
      selectedDoctor,
      dataRequest,
      skipNpiUrl,
      handleSelect,
      nextStep,
    };
  },
});
